import type { mediaViewer as mediaViewerEn } from "../en/mediaViewer";

// Prohlížeč fotek na stránce Média a nová pole detailu fotky.
export const mediaViewer: typeof mediaViewerEn = {
  viewer: {
    dialogLabel: "Prohlížeč fotek",
    prev: "Předchozí fotka",
    next: "Další fotka",
    star: "Označit jako dobrou fotku",
    unstar: "Zrušit označení dobré fotky",
    delete: "Přesunout do koše",
    openDetail: "Otevřít detail",
    close: "Zavřít prohlížeč",
    position: "{{current}} / {{total}}",
    loading: "Načítám fotku…",
    noName: "bez názvu",
  },
  legend: {
    title: "Klávesové zkratky",
    next: "Další fotka",
    prev: "Předchozí fotka",
    star: "Dobrá fotka ano / ne",
    delete: "Přesunout do koše",
    detail: "Otevřít detail",
    close: "Zavřít",
  },
  meta: {
    fileName: "Název souboru",
    dimensions: "Rozměry",
    orientation: "Orientace",
    countries: "Země",
    noCountry: "Bez země",
    source: "Zdroj",
    noSource: "–",
    usageLabel: "Použití",
    usage_one: "Používá se na {{count}} místě",
    usage_few: "Používá se na {{count}} místech",
    usage_other: "Používá se na {{count}} místech",
  },
  tags: {
    label: "Tagy",
    placeholder: "Napište tag a stiskněte Enter",
    add: "Přidat tag",
    remove: "Odebrat tag {{tag}}",
    hint: "Ukládá se hned; hledání v knihovně fotku podle tagů najde.",
  },
  confirmDelete: {
    title: "Přesunout použitou fotku do koše?",
    message_one: "Fotka se používá na {{count}} místě. Opravdu ji přesunout do koše?",
    message_few: "Fotka se používá na {{count}} místech. Opravdu ji přesunout do koše?",
    message_other: "Fotka se používá na {{count}} místech. Opravdu ji přesunout do koše?",
    confirm: "Přesunout do koše",
  },
  drawer: {
    countries: "Země",
    source: "Zdroj",
    sourcePlaceholder: "Odkud fotka je (fotobanka, autor…)",
    starred: "Dobrá fotka",
    liveTwin: "Živá fotka",
  },
  usageKind: {
    destination: "Destinace",
    trip: "Zájezd",
    hotel: "Hotel",
    inspiration: "Inspirace",
    blogPost: "Článek",
    contentPage: "Stránka",
    guide: "Průvodce",
    destinationTeam: "Tým destinace",
    premiumUpgrade: "Prémiový upgrade",
    review: "Recenze",
    departurePhoto: "Fotka odjezdu",
    jobOffer: "Pracovní nabídka",
    newsletterCampaign: "Kampaň newsletteru",
    setting: "Nastavení",
    user: "Uživatel",
  },
};
